import React from "react";
import styles from "./auth.module.css";
import { images, icons } from "assets";
import Text from "Components/shared/text";
import FormControl from "Components/shared/control";
import { InputWithAdornment } from "Components/shared/inputs";
import Button from "Components/shared/button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { createBrowserHistory } from "history";
import {
  StageThree,
  StageOne,
  StageTwo,
  StageFour,
} from "Components/main_components/registeration";
import Hidden from "Components/shared/hidden";
import { HeaderItem, Stages, StageHeader } from "Components/shared/progress";
import useForm from "hooks/useForm";
import validateRegisteration from "utils/validators/registeration";
import { encodeStr } from "utils/stringServices";

const Register = () => {
  const totalStages = 4;
  const navigate = useNavigate();
  const [stage, setStage] = React.useState(1);
  const submitHandler = (values,{errors, setSubmitting, setErrors, resetValues}) => {

  }
  const {handleUpdate, handleChange,handleSubmit,setValues,errors, values,touched} = useForm({initialState:{
    email:"",
    fullName:"",
    country:"",
    countryCode: "",
    phoneNo:"",
    password:"",
    pin:"",
    code:""
  },
  onSubmitHandler: submitHandler,
  validate: validateRegisteration

})

  const handleNext = () => {
    if (!(stage < totalStages)) return;
    if(stage == 1 && (errors.email || errors.fullName)) return;
    else if(stage == 2 && errors.country) return;
    else if(stage == 3 && (errors.phoneNo)) return;
    setStage(stage + 1);
  };
  const handlePrev = () => {
    if (!(stage > 1)) return;
    setStage(stage - 1);
  };

  const finishHandler = (e,email, password) => {
    e.preventDefault();

    //Send info to server then replace
    navigate(`/auth/register-complete?${encodeStr("email")}=${encodeStr(email)}&${encodeStr("password")}=${encodeStr(password)}`, { replace: true });
  };
  return (
    <div className={styles.root}>
      <Hidden mdDown>
        <div className={styles.Info}>
          <div style={{ marginBottom: "1rem" }}>
            <img src={icons.logo} alt="company logo" />
          </div>
          <div className="w-full">
            <Text
              tag="h1"
              style={{ fontWeight: 800, padding: "48px 0px" }}
              variant="xl"
            >
              A few clicks away from creating your Cowrie Exchange account.
            </Text>
            <Text variant="md" color="secondary">
              Transfer money to your loved ones seamlessly and securly
            </Text>
          </div>

          <div className={styles.Bottom}>
            <Text variant="sm" color="secondary">
              Or Login with
            </Text>

            <div className={styles.Social}>
              <Button color="primary">
                <Text style={{ color: "var(--social-color)" }}>Facebook</Text>
                <img
                  src={icons.facebook}
                  alt="facebook"
                  style={{ marginLeft: "8px" }}
                />
              </Button>
              <Button color="primary">
                <Text style={{ color: "var(--social-color)" }}>Google</Text>
                <img
                  src={icons.google}
                  alt="google"
                  style={{ marginLeft: "8px" }}
                />
              </Button>
            </div>
          </div>
        </div>
      </Hidden>
      <Hidden smUp>
        <div style={{ margin: "1rem 24px" }}>
          <img src={icons.logo} alt="company logo" />
        </div>
      </Hidden>
      <form className="w-full">
        <div className={styles.Process}>
          <StageHeader
            currentStage={stage}
            totalStages={totalStages}
            className={styles.StageHeader}
          >
            <HeaderItem active={stage === 1} passed={stage > 1}>
              Email Address
            </HeaderItem>
            <HeaderItem active={stage === 2} passed={stage > 2}>
              Country
            </HeaderItem>
            <HeaderItem active={stage === 3} passed={stage > 3}>
              Phone Number
            </HeaderItem>
            <HeaderItem active={stage === 4} passed={stage > 4}>
              Password
            </HeaderItem>
          </StageHeader>
          
          <Stages active={stage} extraElement={<WaterMark />} {...{handleUpdate, handleSubmit, handleChange,errors, values, touched, setValues}}>
            <StageOne onNext={handleNext} onPrev={handlePrev} />
            <StageTwo onNext={handleNext} onPrev={handlePrev} />
            <StageThree onNext={handleNext} onPrev={handlePrev} />
            <StageFour onNext={finishHandler} onPrev={handlePrev} />
          </Stages>
        </div>
      </form>
    </div>
  );
};

const WaterMark = ({ stage }) => {
  return (
    <div className={styles.WaterContainer}>
      <img
        src={images.watermark}
        alt="watermark"
        className={styles.Watermark}
      />
    </div>
  );
};
export default Register;
